import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
    }

    trigger(e) {

        if(e.mode == 'enter' && e.direction == 'down') {
            html.classList.add('has-nav-visible');
            // document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#E29473');
        }
        if(e.mode == 'leave' && e.direction == 'up') {
            html.classList.remove('has-nav-visible');
            // document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#3A4638');
        }
    }
}
